<template>
  <div>
    <v-flex v-if="terc.length === 6" xs12 pr-2>
      <v-autocomplete
        clearable
        multiple
        v-model="model[field].$model"
        item-text="name"
        item-value="symbol"
        :items="cities"
        :errorMessages="this.model[this.field].$error"
        @focus="focus"
        @blur="blur"
        @change="changeCity"
      >
        <div slot="label">Miejscowości<span v-if="model[field].$schema.fieldRequired"> *</span></div>
      </v-autocomplete>
    </v-flex>
  </div>
</template>

<script>
import axios from 'axios';

import { notificationsMixin } from '@/mixins/notifications';

// @vuese
// Input na SIMC-a
// @group Components/Forms
export default {
  mixins: [notificationsMixin],
  props: {
    // Schema
    model: {
      type: Object,
      required: true
    },
    // Nazwa pola z SIMC-em
    field: {
      type: String,
      required: false,
      default: 'simc'
    },
    // Wartość TERC-a
    terc: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      cities: []
    };
  },
  methods: {
    // @vuese
    // Pobiera listę miejscowości
    getSIMCList() {
      if (this.terc.length === 6) {
        axios
          .get(`${process.env.VUE_APP_TERYT_API_URL}/simc/?terc=${this.terc}`)
          .then(res => {
            this.cities = res.data.list;
            if (this.cities.length === 1) {
              this.changeCity([this.cities[0].symbol]);
            }
          })
          .catch(error => this.notifyError('Nie udało się pobrać listy miejscowości'));
      } else {
        this.cleanSIMC();
      }
    },
    // @vuese
    // Wyczyszczenie formularza
    cleanSIMC() {
      this.cities = [];
      this.model.$setData(
        {
          [this.field]: []
        },
        undefined,
        true
      );
    },
    // @vuese
    // Zapisanie w schema wybranych miejscowości
    changeCity(val) {
      this.model.$setData(
        {
          [this.field]: val ? val : []
        },
        undefined,
        true
      );
    },
    focus() {
      this.model[this.field].$hasFocus = true;
    },
    blur() {
      this.model[this.field].$hasFocus = false;
    }
  },
  watch: {
    terc(newValue) {
      if (newValue) {
        this.getSIMCList();
      } else {
        this.cleanSIMC();
      }
    }
  },
  beforeMount() {
    this.getSIMCList();
  }
};
</script>
